import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import './RFCConfirmationModal.css';

const RFCConfirmationModal = ({ 
    isOpen, 
    onConfirm, 
    onCancel, 
    profileName, 
    changeCount, 
    isSubmitting 
}) => {
    if (!isOpen) return null;
    
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget && !isSubmitting) {
            onCancel();
        }
    };
    
    return (
        <div className="rfc-modal-overlay" onClick={handleOverlayClick}>
            <div className="rfc-modal">
                {/* Header */}
                <div className="rfc-modal-header">
                    <div className="rfc-modal-header-content">
                        <div className="rfc-modal-icon">
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </div>
                        <h3>CRM Approver Review Required</h3>
                    </div>
                    <button 
                        className="rfc-close-btn" 
                        onClick={onCancel}
                        disabled={isSubmitting}
                        type="button"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                
                {/* Body */}
                <div className="rfc-modal-body">
                    <p className="rfc-message">
                        You are editing an <strong>APPROVED</strong> profile. Your changes to{' '}
                        <strong>"{profileName}"</strong> must be reviewed by a CRM Approver before they take effect.
                    </p>
                    
                    <div className="rfc-info-box">
                        <FontAwesomeIcon icon={faInfoCircle} className="rfc-info-icon" />
                        <div className="rfc-info-content">
                            <strong>What happens next:</strong>
                            <ul>
                                <li>Your {changeCount} proposed {changeCount === 1 ? 'change' : 'changes'} will be sent to all CRM Approvers for review</li>
                                <li>You'll be able to view the RFC details using the "RFC Details" button that will appear</li>
                                <li>Once approved by a CRM Approver, all values will be automatically updated and inserted into the profile</li>
                                <li>Your current changes in the form will be discarded and the form will return to the approved values</li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                {/* Footer */}
                <div className="rfc-modal-footer">
                    <button 
                        className="rfc-btn-cancel" 
                        onClick={onCancel} 
                        disabled={isSubmitting}
                        type="button"
                    >
                        Cancel
                    </button>
                    <button 
                        className="rfc-btn-submit" 
                        onClick={onConfirm} 
                        disabled={isSubmitting}
                        type="button"
                    >
                        {isSubmitting ? (
                            <>
                                <span className="rfc-spinner"></span>
                                Submitting RFC...
                            </>
                        ) : (
                            'Submit Request For Changes'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RFCConfirmationModal;

